import { LanguageSwitcher } from '@/components/language-switcher'

import { syncLocaleToProfile } from '../locale'

interface AuthLanguageSwitcherProps {
  className?: string
}

/**
 * Auth-aware locale switch: the shared component persists `kuniri.locale`, and
 * this wrapper additionally mirrors the choice through `PATCH /me` when a
 * session exists (D-038).
 */
export function AuthLanguageSwitcher({ className }: AuthLanguageSwitcherProps) {
  return (
    <LanguageSwitcher
      className={className}
      onLocaleChange={syncLocaleToProfile}
    />
  )
}
